import { combineReducers } from 'redux';

import dirty from './dirty';
import mealOptions, * as fromMealOptions from './mealOptions';
import nutritionSummaries from './nutritionSummaries';
import pendingEdits from './pendingEdits';
import servings from './servings';
import subtotals from './subtotals';
import suggestedPairings from './suggestedPairings';

export default combineReducers({
  dirty,
  mealOptions,
  nutritionSummaries,
  pendingEdits,
  servings,
  subtotals,
  suggestedPairings,
});

export const selectBasketDirty = state => state.dirty;
export const selectMealOptions = state => state.mealOptions;
export const selectNutritionSummaries = state => state.nutritionSummaries;
export const selectServings = state => state.servings;
export const selectSubtotals = state => state.subtotals;
export const selectSuggestedPairings = state => state.suggestedPairings;
export const selectBasketPending = state => state.pendingEdits;

export const selectMealOptionsForMeal = (state, mealId) =>
  fromMealOptions.selectMealOptionsForMeal(state.mealOptions, mealId);
